import { Col } from '@rematter/ui-web';

import { MenuItemGroup } from '../../_types';
import { auditLogRouteGroups } from '../../routes';

import { MenuGroup } from './MenuGroup';

export const AuditLogMenu = () => {
  const menuGroups = auditLogRouteGroups as MenuItemGroup[];

  return (
    <Col className="@AuditLogMenu w-[220px] p-3" gap3>
      <Col gap3>
        {menuGroups.map((group, i) => (
          <MenuGroup
            key={`${i}_${group.groupTitleKey ?? group.items.at(0)?.labelKey}`}
            group={group}
            index={i}
          />
        ))}
      </Col>
    </Col>
  );
};
